// extracted by mini-css-extract-plugin
module.exports = {"auctionTitleAndNavContainer":"AuctionTitleAndNavWrapper_auctionTitleAndNavContainer__2dUbM"};